import TicketList from 'App/pages/ClientCard/ContentPages/Support/ClientContactCardTicketList';

angular.module('domain.contact').controller('ContactSupport', [
	'$scope',
	function ($scope: any) {
		$scope.ContactSupport = TicketList;
	}
]);
